module.exports = __webpack_public_path__ + "media/images/icons/flags/DM-42481df607f8ab8e72a91ca98910537c.svg";